
(function () {
  function removeEmptyHeadings() {
    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');

    headings.forEach(function (heading) {
      const text = heading.textContent.replace(/\u00A0/g, ' ').trim(); // strips &nbsp; too
      const hasImage = heading.querySelector('img, svg');
      const hasIcon  = heading.querySelector('[class*="icon"], [class*="fa-"], [aria-hidden]');

      if (!text && !hasImage && !hasIcon) {
        heading.remove();
      }
    });
  }

  // ── 1. Run on initial DOM ready ──────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeEmptyHeadings);
  } else {
    removeEmptyHeadings();
  }

  // ── 2. Re-run after full page load (catches late-injected content) ──
  window.addEventListener('load', removeEmptyHeadings);

  // ── 3. Watch for 3rd-party / dynamic content added after load ──
  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      const hasNewNodes = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (hasNewNodes) removeEmptyHeadings();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
/* ============================================================
   PASTE THIS AT THE BOTTOM OF YOUR custome.js  (after the
   empty-heading remover block you already added)

   Path: themes/151328194756/Copy of Debut - ADA/assets/custome.js
   ============================================================
   Fixes broken ARIA references:
     • aria-labelledby="id-that-does-not-exist"
     • aria-describedby="id-that-does-not-exist"

   Both attributes accept space-separated lists of IDs.
   This script:
     1. Keeps IDs that resolve to a real DOM element.
     2. Removes IDs that resolve to nothing.
     3. If ALL IDs in the list are broken → removes the
        whole attribute so screen readers aren't confused.
     4. Watches for 3rd-party app injections via
        MutationObserver and cleans those too.
   ============================================================ */

(function () {
  'use strict';

  var ARIA_ATTRS = ['aria-labelledby', 'aria-describedby'];

  // ── Clean one attribute on one element ──────────────────────
  function fixAriaAttr(el, attr) {
    var raw = el.getAttribute(attr);
    if (!raw) return;

    // Split space-separated ID list, filter blanks
    var ids = raw.split(/\s+/).filter(Boolean);
    if (ids.length === 0) {
      el.removeAttribute(attr);
      return;
    }

    // Keep only IDs that exist in the DOM right now
    var validIds = ids.filter(function (id) {
      return !!document.getElementById(id);
    });

    if (validIds.length === 0) {
      // All references are broken → remove the attribute entirely
      el.removeAttribute(attr);
    } else if (validIds.length !== ids.length) {
      // Some were broken → update with only the good ones
      el.setAttribute(attr, validIds.join(' '));
    }
    // If nothing changed, leave it alone
  }

  // ── Scan a subtree for elements with either ARIA attribute ──
  function cleanAriaRefs(root) {
    root = root || document;

    // Build a single selector for efficiency
    var selector = ARIA_ATTRS.map(function (a) {
      return '[' + a + ']';
    }).join(', ');

    var elements = root.querySelectorAll(selector);

    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      ARIA_ATTRS.forEach(function (attr) {
        fixAriaAttr(el, attr);
      });
    }
  }

  // ── Also check the root element itself if it carries the attr
  function cleanElement(node) {
    if (node.nodeType !== 1) return;
    ARIA_ATTRS.forEach(function (attr) {
      fixAriaAttr(node, attr);
    });
    cleanAriaRefs(node); // scan children too
  }

  // ── Pass 1 – run immediately ─────────────────────────────────
  cleanAriaRefs(document);

  // ── Pass 2 – after full DOM parse ────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    cleanAriaRefs(document);
  });

  // ── Pass 3 – after all resources / app scripts finish ────────
  window.addEventListener('load', function () {
    cleanAriaRefs(document);
  });

  // ── Pass 4 – MutationObserver for 3rd-party app injections ───
  var ariaObserver = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var mutation = mutations[m];

      // Newly added subtrees
      for (var n = 0; n < mutation.addedNodes.length; n++) {
        var node = mutation.addedNodes[n];
        if (node.nodeType === 1) {
          cleanElement(node);
        }
      }

      // Attribute change on an existing element
      if (
        mutation.type === 'attributes' &&
        ARIA_ATTRS.indexOf(mutation.attributeName) !== -1
      ) {
        fixAriaAttr(mutation.target, mutation.attributeName);
      }
    }
  });

  ariaObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ARIA_ATTRS
  });

  // Stop observing after 30 s to free memory
  setTimeout(function () {
    ariaObserver.disconnect();
  }, 30000);

})();
/* ============================================================
   ADA FIX — Pop Convert App Accessibility Patch
   Path: themes/151328194756/Copy of Debut - ADA/assets/custome.js
   PASTE THIS AT THE BOTTOM — after your existing blocks

   Fixes all of the following for the Pop Convert popup:
   ┌──────────────────────────────────────────────────────────┐
   │ 1. Popup not announced to screen readers                 │
   │    → role="dialog", aria-modal, aria-label + live region │
   │ 2. Focus does not shift into the popup on open           │
   │    → Focus moves to close button when popup appears      │
   │ 3. No focus trap — Tab escapes the popup                 │
   │    → Tab / Shift+Tab cycles only within the modal        │
   │ 4. Close button is a <div> — not keyboard-reachable      │
   │    → Gets role="button", tabindex, Enter/Space support   │
   │ 5. Escape key does nothing                               │
   │    → Escape now closes popup and restores focus          │
   └──────────────────────────────────────────────────────────┘

   NOTE: This popup runs inside a Shadow DOM (shadowrootmode
   ="open"), so all queries go through the shadow root.
   ============================================================ */

(function () {
  'use strict';

  /* ── State ──────────────────────────────────────────────── */
  var modalOpen     = false;   // is the popup currently visible?
  var prevFocus     = null;    // element focused before popup opened

  /* ── Shadow root accessor ───────────────────────────────── */
  function getRoot() {
    var host = document.getElementById('pop-convert-app');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  /* ── Focusable elements inside the modal ───────────────── */
  function getFocusable(container) {
    var SEL = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
      '[contenteditable="true"]'
    ].join(', ');
    return Array.from(container.querySelectorAll(SEL)).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });
  }

  /* ── Is the backdrop currently visible on screen? ────────── */
  function isBackdropVisible(sr) {
    var bd = sr && sr.getElementById('pc-modal-backdrop');
    if (!bd) return false;
    var cs = window.getComputedStyle(bd);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && bd.offsetHeight > 0;
  }

  /* ── Live-region announcer (outside shadow DOM) ──────────── */
  function announce(msg) {
    var el = document.getElementById('pc-a11y-live');
    if (!el) {
      el = document.createElement('div');
      el.id = 'pc-a11y-live';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      el.style.cssText = [
        'position:absolute',
        'width:1px',
        'height:1px',
        'padding:0',
        'margin:-1px',
        'overflow:hidden',
        'clip:rect(0,0,0,0)',
        'white-space:nowrap',
        'border:0'
      ].join(';');
      document.body.appendChild(el);
    }
    // Clear then set — forces re-announcement even for repeated text
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 60);
  }

  /* ── Apply ARIA attributes to popup elements ─────────────── */
  function applyAria(sr) {
    if (!sr) return;

    var backdrop  = sr.getElementById('pc-modal-backdrop');
    var modalCard = sr.querySelector('.modal-card');
    var closeWrap = sr.getElementById('pc-modal-close-button');
    var closeBtn  = sr.getElementById('pc-main-close-button');

    if (!modalCard) return;

    /* ─ Modal card: dialog role ─────────────────────────────── */
    modalCard.setAttribute('role', 'dialog');
    modalCard.setAttribute('aria-modal', 'true');
    if (!modalCard.hasAttribute('tabindex')) {
      modalCard.setAttribute('tabindex', '-1');
    }

    /* ─ Dialog label: prefer image alt, fall back to default ── */
    if (!modalCard.hasAttribute('aria-labelledby') &&
        !modalCard.hasAttribute('aria-label')) {
      var heading = modalCard.querySelector('h1, h2, h3');
      if (heading) {
        if (!heading.id) heading.id = 'pc-dlg-title';
        modalCard.setAttribute('aria-labelledby', 'pc-dlg-title');
      } else {
        var img = modalCard.querySelector('img[alt]');
        modalCard.setAttribute('aria-label', (img && img.alt) ? img.alt : 'Promotional popup');
      }
    }

    /* ─ Backdrop: decorative role, hide from SR ─────────────── */
    if (backdrop) {
      backdrop.setAttribute('role', 'presentation');
    }

    /* ─ Close button: make it a real keyboard button ─────────── */
    if (closeBtn && !closeBtn.dataset.a11yFixed) {
      closeBtn.dataset.a11yFixed = '1';
      closeBtn.setAttribute('role',     'button');
      closeBtn.setAttribute('tabindex', '0');
      closeBtn.setAttribute('aria-label', 'Close popup');

      closeBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          closeBtn.click();
        }
      });
    }

    /* ─ Wrapper div around close btn: hide from SR ────────────  */
    if (closeWrap) {
      closeWrap.setAttribute('role', 'presentation');
    }

    /* ─ Any other div/span acting as interactive but missing role */
    var clickableDivs = modalCard.querySelectorAll('.clickable-effect:not([role])');
    clickableDivs.forEach(function (el) {
      // Only patch non-anchor, non-button divs/spans
      var tag = el.tagName.toLowerCase();
      if (tag !== 'a' && tag !== 'button' && tag !== 'input') {
        el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        if (!el.dataset.a11yFixed) {
          el.dataset.a11yFixed = '1';
          el.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              el.click();
            }
          });
        }
      }
    });
  }

  /* ── Keyboard handler (focus trap + Escape) ─────────────── */
  function onKeyDown(e) {
    if (!modalOpen) return;
    var sr = getRoot();
    if (!sr) return;
    var modalCard = sr.querySelector('.modal-card');
    if (!modalCard) return;

    /* Escape → close popup */
    if (e.key === 'Escape') {
      e.preventDefault();
      var btn = sr.getElementById('pc-main-close-button');
      if (btn) btn.click();
      return;
    }

    /* Tab → trap focus inside modal */
    if (e.key === 'Tab') {
      var focusable = getFocusable(modalCard);

      // If nothing focusable, block Tab entirely
      if (!focusable.length) {
        e.preventDefault();
        return;
      }

      var first  = focusable[0];
      var last   = focusable[focusable.length - 1];

      // shadowRoot.activeElement gives the focused node inside shadow DOM
      var active = sr.activeElement || document.activeElement;

      if (e.shiftKey) {
        // Shift+Tab: if at first element (or outside modal), wrap to last
        if (active === first || !modalCard.contains(active)) {
          e.preventDefault();
          last.focus();
        }
      } else {
        // Tab: if at last element (or outside modal), wrap to first
        if (active === last || !modalCard.contains(active)) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }

  /* ── When popup opens ────────────────────────────────────── */
  function onOpen(sr) {
    if (modalOpen) return;
    modalOpen = true;

    // Store element that had focus before popup opened
    prevFocus = document.activeElement;

    // Patch ARIA attributes
    applyAria(sr);

    // Shift focus to the close button (or first focusable element)
    setTimeout(function () {
      var modalCard = sr.querySelector('.modal-card');
      var closeBtn  = sr.getElementById('pc-main-close-button');
      var target    = closeBtn
        || (modalCard && getFocusable(modalCard)[0])
        || modalCard;
      if (target) target.focus();
    }, 150);

    // Announce to screen reader
    var label = '';
    var sr2   = getRoot();
    if (sr2) {
      var mc  = sr2.querySelector('.modal-card');
      var img = mc && mc.querySelector('img[alt]');
      label = img && img.alt ? img.alt : 'Promotional popup';
    }
    announce(label + '. Dialog opened. Press Escape to close.');

    // Activate keyboard handler
    document.addEventListener('keydown', onKeyDown);
  }

  /* ── When popup closes ───────────────────────────────────── */
  function onClose() {
    if (!modalOpen) return;
    modalOpen = false;

    // Remove keyboard handler
    document.removeEventListener('keydown', onKeyDown);

    // Restore focus to the previously focused element
    if (prevFocus && typeof prevFocus.focus === 'function') {
      setTimeout(function () { prevFocus.focus(); }, 100);
    }

    announce('Popup closed.');
  }

  /* ── Watch for popup open / close state changes ──────────── */
  function watchModal(sr) {
    // Patch immediately in case popup is already open
    applyAria(sr);

    if (isBackdropVisible(sr)) {
      onOpen(sr);
    }

    /* Watch the host element for display:none / display:block */
    var host = document.getElementById('pop-convert-app');
    if (host) {
      new MutationObserver(function () {
        var vis = isBackdropVisible(sr);
        if (vis && !modalOpen)  onOpen(sr);
        if (!vis && modalOpen)  onClose();
      }).observe(host, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    /* Watch the backdrop for style/class changes */
    var backdrop = sr.getElementById('pc-modal-backdrop');
    if (backdrop) {
      new MutationObserver(function () {
        var vis = isBackdropVisible(sr);
        if (vis && !modalOpen)  onOpen(sr);
        if (!vis && modalOpen)  onClose();
      }).observe(backdrop, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    /* Watch shadow root for DOM rebuilds (Vue re-rendering) */
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.addedNodes.length) applyAria(sr);
      });
    }).observe(sr, { childList: true, subtree: true });
  }

  /* ── Wait until the popup host + shadow root exist ───────── */
  function init() {
    var sr = getRoot();
    if (sr && sr.getElementById('pc-modal-backdrop')) {
      watchModal(sr);
      return;
    }

    // Poll until the popup is injected into the page
    var tries = 0;
    var interval = setInterval(function () {
      tries++;
      var sr2 = getRoot();
      if (sr2 && sr2.getElementById('pc-modal-backdrop')) {
        clearInterval(interval);
        watchModal(sr2);
        return;
      }
      // Give up after 60 s
      if (tries > 120) clearInterval(interval);
    }, 500);

    // Also watch the DOM for the host element being added
    new MutationObserver(function (mutations, obs) {
      var sr3 = getRoot();
      if (!sr3) return;
      var bd = sr3.getElementById('pc-modal-backdrop');
      if (!bd) return;
      obs.disconnect();
      watchModal(sr3);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ── Boot ────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
// H1 heading — visually hidden, zero layout impact
(function () {
  function addHiddenH1FromTitle() {
    // ── 1. Check if page already has an h1 ──────────────────────
    const existingH1 = document.querySelector('h1');
    if (existingH1) return;

    // ── 2. Get text from <title>, strip site name after separator ─
    const rawTitle = document.title || '';
    const pageTitle = rawTitle
      .split(/[|\-–—]/)
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; })[0] || rawTitle.trim();

    if (!pageTitle) return;

    // ── 3. Create visually hidden h1 ────────────────────────────
    const h1 = document.createElement('h1');
    h1.textContent = pageTitle;

    // setAttribute (not .style.cssText) is required for !important to work.
    // !important ensures the page's own h1 CSS rules can't override hiding.
    h1.setAttribute('style', [
      'position: absolute !important',
      'width: 1px !important',
      'height: 1px !important',
      'padding: 0 !important',
      'margin: 0 !important',          // was -1px — not needed on absolute elements
      'overflow: hidden !important',
      'clip: rect(0, 0, 0, 0) !important',
      'clip-path: inset(50%) !important', // modern equivalent of clip
      'white-space: nowrap !important',
      'border: 0 !important'
    ].join('; '));

    // ── 4. Inject as first child of <body>, NOT inside <main>/hero ─
    // Keeps heading hierarchy intact for screen readers while
    // completely removing it from hero/main layout context.
    document.body.insertBefore(h1, document.body.firstChild);
  }

  // ── Run on DOM ready ─────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addHiddenH1FromTitle);
  } else {
    addHiddenH1FromTitle();
  }
})();
//aria
/**
 * Accessibility Fix Script
 *
 * Resolves two axe violations:
 *  1. aria-hidden-focus  — focusable elements inside aria-hidden containers
 *                          must have tabindex="-1" so they are unreachable by
 *                          keyboard and assistive technology.
 *  2. aria-allowed-attr  — aria-selected is only valid on roles: gridcell,
 *                          option, row, tab, columnheader, rowheader, treeitem.
 *                          Plain <li> elements must not carry it.
 *
 * Works with Slick Slider (and any similar dynamic carousel) by using a
 * MutationObserver so fixes re-apply whenever the slider mutates the DOM.
 *
 * Usage – include after your slider initialises, e.g.:
 *   <script src="fix-aria-accessibility.js" defer></script>
 */

(function () {
  "use strict";

  // ─── Selectors ────────────────────────────────────────────────────────────

  /** All normally-focusable element types */
  const FOCUSABLE_SELECTOR = [
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "details > summary",
    "[contenteditable]:not([contenteditable='false'])",
    "[tabindex]:not([tabindex='-1'])",
  ].join(",");

  /**
   * Roles on which aria-selected is semantically valid.
   * https://www.w3.org/TR/wai-aria-1.2/#aria-selected
   */
  const ARIA_SELECTED_ALLOWED_ROLES = new Set([
    "gridcell",
    "option",
    "row",
    "tab",
    "columnheader",
    "rowheader",
    "treeitem",
  ]);

  // ─── Fix 1: aria-hidden-focus ─────────────────────────────────────────────

  /**
   * For every element with aria-hidden="true", find all focusable descendants
   * and set tabindex="-1" on them so they cannot receive keyboard focus.
   */
  function fixAriaHiddenFocus() {
    document
      .querySelectorAll('[aria-hidden="true"]')
      .forEach((container) => {
        container.querySelectorAll(FOCUSABLE_SELECTOR).forEach((el) => {
          // Only stamp tabindex if we haven't already, to avoid infinite loops
          // with the MutationObserver watching attribute changes.
          if (el.getAttribute("tabindex") !== "-1") {
            el.setAttribute("tabindex", "-1");
          }
        });
      });
  }

  // ─── Fix 2: aria-allowed-attr (aria-selected on <li>) ────────────────────

  /**
   * Remove aria-selected from any element whose implicit or explicit ARIA
   * role does not support the attribute.
   *
   * Slick Slider sets aria-selected on <li> dot indicators which have no
   * matching role, making it an invalid attribute.  The correct pattern for
   * a tab-like indicator is role="tab" + aria-selected, or simply to drive
   * the active state through a class / aria-current instead.
   *
   * This fix:
   *   - keeps aria-selected where the role allows it, and
   *   - removes it otherwise (the visual/active state is preserved via the
   *     existing class that the slider already manages).
   */
  function fixInvalidAriaSelected() {
    document.querySelectorAll("[aria-selected]").forEach((el) => {
      const explicitRole = el.getAttribute("role");

      // <option> inside <select> supports aria-selected natively
      const isNativeOption = el.tagName.toLowerCase() === "option";

      const isAllowed =
        isNativeOption ||
        (explicitRole && ARIA_SELECTED_ALLOWED_ROLES.has(explicitRole));

      if (!isAllowed) {
        el.removeAttribute("aria-selected");
      }
    });
  }

  // ─── Runner ───────────────────────────────────────────────────────────────

  function applyFixes() {
    fixAriaHiddenFocus();
    fixInvalidAriaSelected();
  }

  // Run immediately once the DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyFixes);
  } else {
    applyFixes();
  }

  // ─── MutationObserver: re-apply on dynamic DOM changes ───────────────────
  // Slick re-renders aria-hidden and aria-selected attributes as the user
  // navigates slides, so we observe and patch in real time.

  const observer = new MutationObserver((mutations) => {
    let needsFocusFix = false;
    let needsSelectedFix = false;

    for (const mutation of mutations) {
      if (mutation.type === "attributes") {
        const attr = mutation.attributeName;
        if (attr === "aria-hidden") needsFocusFix = true;
        if (attr === "aria-selected") needsSelectedFix = true;
      }

      if (mutation.type === "childList" && mutation.addedNodes.length) {
        // New nodes might introduce either violation
        needsFocusFix = true;
        needsSelectedFix = true;
      }

      if (needsFocusFix && needsSelectedFix) break; // nothing more to check
    }

    if (needsFocusFix) fixAriaHiddenFocus();
    if (needsSelectedFix) fixInvalidAriaSelected();
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["aria-hidden", "aria-selected", "tabindex"],
  });
})();
//product color
(function () {
  var COLORS = {
    '100': '#278634',   // Best Value  — was #41C853
    '101': '#E70404'    // Contact Us  — was #FB1A1A
  };

  function applyColors() {
    var found = 0;

    Object.keys(COLORS).forEach(function (qty) {
      var el = document.querySelector('.mce-prices-tier [data-qty="' + qty + '"]');
      if (el) {
        el.style.setProperty('--mce-badge-bg', COLORS[qty]);
        found++;
      }
    });

    return found === Object.keys(COLORS).length; // true = both items found & updated
  }

  // ── 1. Try immediately (works if HTML is already in the DOM) ───
  if (applyColors()) return;

  // ── 2. MCE widget not in DOM yet — watch for it ───────────────
  var observer = new MutationObserver(function (_, obs) {
    if (applyColors()) {
      obs.disconnect();   // ✅ both updated — stop watching
    }
  });

  observer.observe(document.documentElement, {
    childList: true,   // watch for added/removed nodes
    subtree: true      // anywhere in the tree
  });

  // ── 3. Hard fallback — disconnect after 10 s regardless ───────
  setTimeout(function () {
    applyColors();       // last attempt
    observer.disconnect();
  }, 10000);

})();
// radio app
(function () {
  'use strict';

  // ── Helpers ──────────────────────────────────────────────────────────

  /**
   * Strip any price fragment we injected in a previous run
   * e.g. "One-time purchase, $7.70" → "One-time purchase"
   * Prevents duplicates when the observer re-fires on price updates.
   */
  function stripInjectedPrice(label) {
    return label.replace(/,\s*\$[\d.,].*$/, '').trim();
  }

  // ── Core fix — idempotent, safe to call multiple times ───────────────

  function applyFixes() {
    var container = document.querySelector('.sealsubs-container');
    if (!container) return false;

    var optContainers = container.querySelectorAll('.sls-option-container');
    if (!optContainers.length) return false;

    optContainers.forEach(function (optContainer) {
      var radioDiv = optContainer.querySelector('[role="radio"]');
      if (!radioDiv) return;

      // ── Fix 1: Remove duplicate AT exposure ────────────────────────
      // div[role="radio"] already exposes full radio semantics.
      // The native <input type="radio"> inside it causes screen readers
      // to announce the option twice. Hiding it from AT resolves this
      // without breaking form submission or the app's click/keyboard logic.
      var nativeInput = radioDiv.querySelector('input[type="radio"]');
      if (nativeInput && nativeInput.getAttribute('aria-hidden') !== 'true') {
        nativeInput.setAttribute('aria-hidden', 'true');
      }

      // ── Fix 2: Associate price with its radio option ────────────────
      // Without this, screen readers announce only "One-time purchase,
      // radio button, checked" — the price is never read.
      var priceEl   = optContainer.querySelector('.sls-price .money');
      var savingsEl = optContainer.querySelector('.sls-savings-badge');

      if (!priceEl) return;

      var price   = priceEl.textContent.trim();                         // "$7.70"
      var savings = savingsEl ? savingsEl.textContent.trim() : '';      // "SAVE 5%"

      // Build: "One-time purchase, $7.70"
      //     or "Subscribe & Save!, $7.32, SAVE 5%"
      var currentLabel = radioDiv.getAttribute('aria-label') || '';
      var baseLabel    = stripInjectedPrice(currentLabel);
      var newLabel     = baseLabel + ', ' + price;
      if (savings) newLabel += ', ' + savings;

      // Only write if something actually changed (avoids observer loops)
      if (currentLabel !== newLabel) {
        radioDiv.setAttribute('aria-label', newLabel);
      }
    });

    return true;
  }

  // ── Phase 2 observer: re-apply when prices update ────────────────────
  // Fires when the app updates price text (e.g. variant change).
  // Scoped tightly to .sealsubs-container to stay lightweight.

  function watchPriceUpdates() {
    var container = document.querySelector('.sealsubs-container');
    if (!container) return;

    new MutationObserver(function () {
      applyFixes();
    }).observe(container, {
      subtree       : true,
      childList     : true,   // app replaces price nodes on variant change
      characterData : true    // app mutates price text nodes directly
    });
  }

  // ── Phase 1 observer: wait for the widget to be injected ─────────────
  // Seal Subscriptions renders asynchronously, so the container may not
  // exist when this script first runs.

  function waitForWidget() {
    var initObserver = new MutationObserver(function (_, obs) {
      if (applyFixes()) {
        obs.disconnect();          // widget found — switch to price watcher
        watchPriceUpdates();
      }
    });

    initObserver.observe(document.documentElement, {
      childList : true,
      subtree   : true
    });

    // Hard stop after 15 s — don't observe forever if widget never loads
    setTimeout(function () {
      initObserver.disconnect();
    }, 15000);
  }

  // ── Entry point ───────────────────────────────────────────────────────

  function init() {
    if (applyFixes()) {
      watchPriceUpdates();  // widget already in DOM — jump straight to phase 2
    } else {
      waitForWidget();      // widget not ready — start phase 1 observer
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();